import styled from 'styled-components';
import primitives from '@veneer/primitives';
import { Search as VeneerSearch } from '@veneer/core';
import { GenericModal, mixins } from '@jarvis/react-portal-addons';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${primitives.layout.size2}px;

  ${mixins.sm(`
    gap: ${primitives.layout.size5}px;
  `)}
`;

export const Timestamp = styled.span`
  color: ${props => (props.red ? primitives.color.red6 : '')};
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.orbitalFour};
  flex-grow: 1;

  .custom-select {
    max-width: 200px;
  }

  @media screen and (max-width: ${primitives.layout.breakpoint2}px) {
    flex-direction: column;
    align-items: flex-start;
    .custom-select {
      max-width: 100%;
    }
  }
`;

export const Search = styled(VeneerSearch)`
  max-width: 400px;
  width: 100%;

  & #search-model-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media screen and (max-width: ${primitives.layout.breakpoint2}px) {
    max-width: 100%;
  }
`;

export const StyledGenericModal = styled(GenericModal)`
  && {
    max-width: calc(100% - 32px) !important;
    width: calc(100% - 32px) !important;
    
    ${mixins.sm(`
      max-width: calc(100% - 40px) !important;
      width: calc(100% - 40px) !important;
    `)}
    
    ${mixins.md(`
      max-width: calc(100% - 32px) !important;
      width: calc(100% - 32px) !important;
    `)}
    
    ${mixins.lg(`
      max-width: calc(100% - 48px) !important;
      width: calc(100% - 48px) !important;
    `)}
    
    @media (min-width: 1200px) {
      max-width: calc(100% - 32px) !important;
      width: calc(100% - 32px) !important;
    }
  }

  .vn-modal--content {
    ${mixins.xs(`
      margin: ${primitives.layout.size4}px;
      padding: 40px ${primitives.layout.size5}px ${primitives.layout.size5}px;
    `)}

    ${mixins.md(`
      margin: ${primitives.layout.size4}px;
      padding: 40px ${primitives.layout.size5}px ${primitives.layout.size5}px;
    `)}

    ${mixins.lg(`
      margin: ${primitives.layout.size6}px;
      padding: 40px ${primitives.layout.size6}px ${primitives.layout.size6}px;
    `)}

    @media (min-width: 1200px) {
      margin: ${primitives.layout.size4}px;
      padding: 40px ${primitives.layout.size5}px ${primitives.layout.size5}px;
    }

    & > div > div {
      gap: ${({ theme }) => theme.orbitalFive};
    }
  }
`;

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${primitives.layout.size4}px;
`;
